import { KBSpin } from '@/components/atoms/KBSpin'
import { KBEmpty } from '@/components/organisms/KBEmpty'
import { List, ListProps } from 'antd'

export interface KBListProps<T> extends ListProps<T> {
  emptyTitle?: string
  emptyDescription?: string
}

export function KBList<T>(props: KBListProps<T>) {
  const { emptyTitle, emptyDescription, ...listProps } = props
  return (
    <List
      locale={{
        emptyText: !props.loading ? (
          <KBEmpty title={emptyTitle} description={emptyDescription} />
        ) : (
          <KBSpin />
        ),
      }}
      {...listProps}
    ></List>
  )
}

KBList.Item = List.Item
